import { render } from "./Attention.vue?vue&type=template&id=1f55b7bb"
import script from "./Attention.vue?vue&type=script&lang=ts"
export * from "./Attention.vue?vue&type=script&lang=ts"
script.render = render

export default script